/*
 * We need this in order to address a problem with the React 18 compatible version of react_on_rails
 * and mini_racer. See https://github.com/shakacode/react_on_rails/issues/1457#issuecomment-1165026717
 * Polyfill TextEncoder & TextDecoder onto `util` b/c `node-util` polyfill doesn't include them
 */
import util from 'util';
import 'fast-text-encoding';
Object.assign(util, {
  TextDecoder: TextDecoder,
  TextEncoder: TextEncoder
});